export default __webpack_public_path__ + "static/media/profile_icon.7b3be2a2.svg";